function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Folder",
  transform: "translate(-306.000000, -236.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(306.000000, 196.000000)",
  id: "folder"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 40.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-3-Copy",
  fill: "#71B9F4",
  x: 0,
  y: 6,
  width: 37,
  height: 24,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.9824903,4 L35,4 C36.1045695,4 37,4.8954305 37,6 L37,26 C37,27.1045695 36.1045695,28 35,28 L16,28 L2,28 C0.8954305,28 1.3527075e-16,27.1045695 0,26 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L12.7373843,-4.4408921e-16 C13.2285472,-5.34314366e-16 13.7025368,0.180735938 14.069004,0.507756998 L17.9824903,4 Z",
  id: "Combined-Shape",
  fill: "#92CEFF"
})))));

var SvgFolder = function SvgFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "30px",
    viewBox: "0 0 37 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folder.6eb08f6d.svg";
export { ForwardRef as ReactComponent };